<div class="p-2">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <h2>Reservations In-Out Report</h2>

  <div class="reservationsTable">
    <p-table #pt [value]="reservations" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[50,100,200]"
      [totalRecords]="recordTotal" [lazy]="true" (onLazyLoad)="loadLazy($event)" sortMode="multiple"
      [multiSortMeta]="multiSortMeta" selectionMode="single"
      [globalFilterFields]="['guestProfileVO.lastName','guestProfileVO.firstName','guestProfileVO.emailAddress','reservationId','orderId','reservationConfId','saleDate','checkInDate','checkOutDate','shortTermRentalVO.propertyCode','orderVO.orderIdMask', 'confirmationNumber']"
      [filterDelay]="1000" [(selection)]=" reservation" dataKey="reservationId" (onRowSelect)="onRowSelect($event)"
      showCurrentPageReport="true" [loading]="loading" [responsive]="true" styleClass="p-datatable-striped"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}">

      <ng-template pTemplate="caption">
        <div class="flex justify-content-between">
          <div class="mr-2">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input #global pInputText type="text" [(ngModel)]="searchName"
                (input)="pt.filterGlobal($event.target.value, 'contains')" placeholder="Search" />
            </span>
            <button
              pButton
              pRipple
              class="ml-3 p-button-text advanced-search-btn"
              (click)="onAdvanceSearch()">
              Advanced Search
              @if (advanceSearchData && getAdvanceSearchDataCount() > 0) {
                <sup
                  class="filter-count-badge">
                  {{ getAdvanceSearchDataCount() }}
                </sup>
              }
            </button>

            <!-- <button pButton label="Clear" class="ml-2 p-button-outlined" icon="pi pi-filter-slash"
          (click)="clear(pt);"></button> -->
        </div>
        <!-- <div class="mr-2">
        <span class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
            placeholder="Search" />
        </span>
      </div> -->
      <div class="d-block text-end">
        <span>
          <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50"
            [dataRetrived]="reservations" (exportDataSelected)="exportSelected($event)" importEnabled="false"
          [sampleFileLink]="sampleLink" [columns]="columns" [importDisabled]="true"></app-import-export>
          <!--clear filters-->
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>

          <!-- <button pButton pRipple class="p-button-text"
          title="If you need help or are experiencing any difficulties, please call Dipesh on Ring Central at extension 907."
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="openHelpAlert()">Need Help?</button> -->

        <!--add new-->
        <!-- <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      routerLink="/reservation-add">New Reservation +</button> -->
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="generateWelcomeCardFromListWithFilter()">Generate Welcome Card</button>
      <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      (click)="openCreateReservationPopUp()">New Reservation +</button>
    </span>
  </div>
</div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    <th>Status</th>
    <th [pSortableColumn]="'reservationInOutType'">Reservation In/Out
      <p-sortIcon [field]="'reservationInOutType'"></p-sortIcon>
    </th>
    <th>Location</th>
    <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Unit
      <p-sortIcon [field]="'shortTermRentalVO.propertyCode'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'guestProfileVO.lastName'">Name
      <p-sortIcon [field]="'guestProfileVO.lastName'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'checkInDateTime'">In
      <p-sortIcon [field]="'checkInDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'checkOutDateTime'">Out
      <p-sortIcon [field]="'checkOutDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'numberOfNightsStay'">Nights
      <p-sortIcon [field]="'numberOfNightsStay'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'numAdults'">Guests
      <p-sortIcon [field]="'numAdults'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'invoiceTotal'">Invoice Total
      <p-sortIcon [field]="'invoiceTotal'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'revRoomRateNetPNT'">Rate
      <p-sortIcon [field]="'revRoomRateNetPNT'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'outStandingBalance'">Balance
      <p-sortIcon [field]="'outStandingBalance'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'shortTermRentalVO.occupancyStatus'">Room Status
      <p-sortIcon [field]="'shortTermRentalVO.occupancyStatus'"></p-sortIcon>
    </th>
    <th [ngStyle]="{'width': 'auto'}">Tags</th>
    <th [pSortableColumn]="'accessCodeFrontDoor'">Door Code
      <p-sortIcon [field]="'accessCodeFrontDoor'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'accessCodeGarageDoor'">Garage Code
      <p-sortIcon [field]="'accessCodeGarageDoor'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'accessCodePropertyGate'">Gate Code
      <p-sortIcon [field]="'accessCodePropertyGate'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'accessCodeHoaGate'">HOA Gate Code
      <p-sortIcon [field]="'accessCodeHoaGate'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'accessCodePool'">Pool Code
      <p-sortIcon [field]="'accessCodePool'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'towelCode'">Towel Code
      <p-sortIcon [field]="'towelCode'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'accessCodeRecreation'">Code Recreation
      <p-sortIcon [field]="'accessCodeRecreation'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'rentalCarAvis'">Avis
      <p-sortIcon [field]="'rentalCarAvis'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'rentalCarBudget'">Budget
      <p-sortIcon [field]="'rentalCarBudget'"></p-sortIcon>
    </th>
    <th class="text-nowrap" [pSortableColumn]="'guestNotes'">Comm Status
      <p-sortIcon [field]="'guestNotes'"></p-sortIcon>
    </th>
    <th>Comments</th>
    <th [pSortableColumn]="'gapNightsBeforeAfter'">Gap Nts B/A
      <p-sortIcon [field]="'gapNightsBeforeAfter'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'earlyCheckinDateTime'">Early In
      <p-sortIcon [field]="'earlyCheckinDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'propertyArrivalDateTime'">Room Arrival
      <p-sortIcon [field]="'propertyArrivalDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'propertyDepartureDateTime'">Room Departure
      <p-sortIcon [field]="'propertyDepartureDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'airportArrivalDateTime'">Airport In
      <p-sortIcon [field]="'airportArrivalDateTime'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'airportDepartureDateTime'">Airport Out
      <p-sortIcon [field]="'airportDepartureDateTime'"></p-sortIcon>
    </th>
    <th>Order #</th>
    <th>Res #</th>
    <th>Channel</th>
    <th [pSortableColumn]="'orderVO.creditSaleToUserVO.lastName'">Sales Agent Name
      <p-sortIcon [field]="'orderVO.creditSaleToUserVO.lastName'"></p-sortIcon>
    </th>
    <th [pSortableColumn]="'createDate'">Created
      <p-sortIcon [field]="'createDate'"></p-sortIcon>
    </th>
  </tr>
  <tr>
    <th>
      <p-multiSelect dropdownIcon="fa fa-caret-down" [options]="reservationStatuses" defaultLabel="Status"
      (onChange)="pt.filter($event.value, 'reservationStatus', 'in')" appendTo="body"></p-multiSelect>
    </th>
    <th [ngStyle]="{'width': 'auto'}">
      <p-multiSelect dropdownIcon="fa fa-caret-down" [options]="reservationInOutTypes" optionLabel="label" optionValue="value" defaultLabel="In/Out"
      (onChange)="pt.filter($event.value, 'reservationInOutType', 'in')" appendTo="body"></p-multiSelect>
    </th>
    <th>
      <p-dropdown dropdownIcon="fa fa-caret-down" [style]="{'width':'auto','min-width':'100%'}" [options]="locations" appendTo="body"
        (onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter" placeholder="Filter"
        [showClear]="true" optionLabel="name" optionValue="locationId"
        [value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
    </th>
    <th>
      <input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'startsWith')">
    </th>
    <th>
      <input pInputText style="width:150px;" type="text"
        (input)="pt.filter($event.target.value, 'guestProfileVO.lastName', 'startsWith')">
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
    style="width:100px;" type="date" [value]="isAdvanceFilterActive ? '' : todayDateInput" (input)="pt.filter($event.target.value, 'checkInDateTime', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
    style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'checkOutDateTime', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'numberOfNightsStay', 'contains')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'numAdults', 'contains')"></th>
    <th [ngStyle]="{'width': 'auto'}"></th>
    <th [ngStyle]="{'width': 'auto'}"></th> <!-- Rate -->
    <th [ngStyle]="{'width': 'auto'}"></th> <!-- Balance -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'occupancyStatus', 'contains')"></th> <!-- Room Status -->
    <th [ngStyle]="{'width': 'auto'}">
      <p-multiSelect dropdownIcon="fa fa-caret-down" [options]="tags" defaultLabel="Tags"
      (onChange)="pt.filter($event.value, 'tagJoinAPIS', 'in')" appendTo="body"></p-multiSelect>
    </th> <!-- Tags -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodeFrontDoor', 'in')"></th> <!-- Door Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodeGarageDoor', 'in')"></th> <!-- Garage Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodePropertyGate', 'in')"></th> <!-- Gate Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodeHoaGate', 'in')"></th> <!-- HOA Gate Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'towelCode', 'in')"></th> <!-- Towel Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodeRecreation', 'in')"></th> <!-- CodeRecreation Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'accessCodePool', 'in')"></th> <!-- Pool Code -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'rentalCarAvis', 'in')"></th> <!-- Avis -->
    <th [ngStyle]="{'width': 'auto'}"><input pInputText style="width:100px;" type="text"
    (input)="pt.filter($event.target.value, 'rentalCarBudget', 'in')"></th> <!-- Budget -->
    <th [ngStyle]="{'width': 'auto'}"></th> <!-- Comm Status -->
    <th [ngStyle]="{'width': 'auto'}">
      <input pInputText style="width:100%;" type="text"
        (input)="pt.filter($event.target.value, 'opsNotes', 'contains')">
    </th> <!-- Comments -->
    <th [ngStyle]="{'width': 'auto'}">
      <input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'gapNightsBeforeAfter', 'contains')">
    </th> <!-- Gap Nts -->
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
      style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'earlyCheckinDateTime', 'in')">
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
      style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'propertyArrivalDateTime', 'in')">
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
      style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'propertyDepartureDateTime', 'in')">
    </th>

    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
      style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'airportArrivalDateTime', 'in')">
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'auto','min-width':'100%'}" pInputText
      style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'airportDepartureDateTime', 'in')">
    </th>
    <th>
      <input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'orderVO.orderId', 'contains')">
    </th>
    <th>
      <input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'reservationId', 'contains')">
    </th>
    <th>
      <p-multiSelect dropdownIcon="fa fa-caret-down" [options]="constantService.refSrcImages" defaultLabel="Channel"
      (onChange)="pt.filter($event.value, 'orderVO.referralSourceId', 'in')" appendTo="body"></p-multiSelect>
    </th>
    <th>
      <input pInputText style="width:100px;" type="text"
        (input)="pt.filter($event.target.value, 'orderVO.creditSaleToUserVO.lastName', 'contains')">
    </th>
    <th>
      <input pInputText style="width:100px;" type="date" (input)="pt.filter($event.target.value, 'createDate', 'in')">
    </th>
  </tr>
</ng-template>

<ng-template pTemplate="body" let-reservation>
  <tr [pSelectableRow]="reservation">
    <td [style.background-color]="getResStatusColor(reservation.reservationStatus)">
      <span class="status-text"
      >{{getResStatusName(reservation.reservationStatus)}}</span>
    </td>
    <td>{{reservation.reservationInOutType}}</td>
    <td>{{getLocationName(reservation.locationId)}} </td>
    <td>{{reservation.propertyCode}}</td>
    <td><b>{{reservation.guestLastName}}</b></td>
    <td style="white-space: nowrap;">{{reservation?.checkInDate ? (reservation.checkInDate |date:'MM/dd/yy') : '-'}}</td>
    <td style="white-space: nowrap;">{{reservation?.checkOutDate ? (reservation.checkOutDate |date:'MM/dd/yy') : '-'}}</td>
    <td style="text-align: center;">{{reservation?.numNights}}</td>
    <td>{{reservation?.numAdults}}/{{reservation?.numChildren}} {{reservation?.numPets}}</td>
    <td>{{reservation.invoiceTotal|currency}}</td>
    <td>{{reservation.revRoomRateNetPNT|currency}}</td>
    <td>{{reservation.outStandingBalance|currency}}</td>
    <td [style.background-color]="reservation.roomOccupancyStatusColor"><span class="status-text"
    >{{reservation.roomOccupancyStatusName}}</span>
  </td>
  <td>{{getTagNameFromTagList(reservation.tagJoinAPIS)}}</td>
  <td>{{reservation.accessCodeFrontDoor}}</td>
  <td>{{reservation.accessCodeGarageDoor}}</td>
  <td>{{reservation.accessCodePropertyGate}}</td>
  <td>{{reservation.accessCodeHoaGate}}</td>
  <td>{{reservation.accessCodePool}}</td>
  <td>{{reservation.towelCode}}</td>
  <td>{{reservation.accessCodeRecreation}}</td>
  <td>{{reservation.rentalCarAvis}}</td>
  <td>{{reservation.rentalCarBudget}}</td>
  <td>{{reservation.guestNotes}}</td>
  <td style="width: 400px !important">
    <div class="ops-notes-container">
      @if (reservation?.opsNotes) {
        @if (!isOpsNotesExpanded(reservation.reservationId)) {
          <span>
            {{ reservation.opsNotes | slice:0:50 }}@if (needsTruncation(reservation.opsNotes)) {
            <span>...</span>
          }
          @if (needsTruncation(reservation.opsNotes)) {
            <button class="view-more-btn"
            (click)="toggleOpsNotes(reservation.reservationId)">Read more</button>
          }
        </span>
      }
      @if (isOpsNotesExpanded(reservation.reservationId)) {
        <span>
          {{ reservation.opsNotes }}
          <button class="view-more-btn" (click)="toggleOpsNotes(reservation.reservationId)">Read less</button>
        </span>
      }
    }
    @if (!reservation?.opsNotes) {
      N/A
    }
  </div>
</td>
<td>{{reservation.gapNightsBeforeAfter}}</td>
<td class="text-nowrap">{{ reservation?.earlyCheckinDateTime ? (reservation.earlyCheckinDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
<td class="text-nowrap">{{ reservation?.propertyArrivalDateTime ? (reservation.propertyArrivalDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
<td class="text-nowrap">{{ reservation?.propertyDepartureDateTime ? (reservation.propertyDepartureDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
<td class="text-nowrap">{{ reservation?.airportArrivalDateTime ? (reservation.airportArrivalDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
<td class="text-nowrap">{{ reservation?.airportDepartureDateTime ? (reservation.airportDepartureDateTime | date:'MM/dd/yyyy hh:mm a') : '-' }}</td>
<td>{{reservation.orderId}} </td>
<td>{{reservation.reservationId}}</td>
<td><img style='height: 23px; width: 80px'
src='{{constantService.getChannelPictureURL(reservation.referralSourceId)}}' /></td>
<td>{{reservation.salesAgentLastName}}</td>
<td>{{reservation?.createDate ? (reservation.createDate |date:'MM/dd/yy hh:mm a') : '-'}}</td>
</tr>
</ng-template>
<ng-template pTemplate=" paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
  {{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>
</div>
</div>